import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { deleteRent, editRent, getRent, updateRent } from '../rentThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'rent';

export const rentSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getRent });
        handleRequestThunk({ builder, request: deleteRent, isDelete: true });
        handleRequestThunk({ builder, request: editRent });
        handleRequestThunk({ builder, request: updateRent });
    },
});

export const rent = rentSlice.reducer;
